import * as React from "react";
import { CustomCell, CustomRenderer, GridCellKind } from "@glideapps/glide-data-grid";

export interface ButtonCellProps {
  readonly kind: "button-cell";
  readonly label: string;
  readonly onClick: (id?: string) => void;
  readonly value: any;
  readonly disabled?: boolean;
}

export type ButtonCell = CustomCell<ButtonCellProps>;

export const ButtonCellRenderer: CustomRenderer<ButtonCell> = {
  kind: GridCellKind.Custom,

  isMatch: (c): c is ButtonCell =>
    c.kind === GridCellKind.Custom && (c.data as any).kind === "button-cell",

  draw: (args, cell) => {
    const { ctx, theme, rect, hoverX, hoverY } = args;
    const { label } = cell.data;

    const isHovered =
      hoverX !== undefined &&
      hoverY !== undefined &&
      hoverX >= rect.x &&
      hoverX <= rect.x + rect.width &&
      hoverY >= rect.y &&
      hoverY <= rect.y + rect.height;

    ctx.save();
    ctx.beginPath();
    ctx.rect(rect.x, rect.y, rect.width, rect.height);
    ctx.clip();

    // colores dinámicos
    const bgColor = isHovered ? "#0078d4" : theme.bgCell;
    const textColor = isHovered ? "#ffffff" : theme.textDark;

    // fondo redondeado
    const radius = 10;
    const x = rect.x + 4;
    const y = rect.y + 4;
    const w = rect.width - 8;
    const h = rect.height - 8;

    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.lineTo(x + w - radius, y);
    ctx.quadraticCurveTo(x + w, y, x + w, y + radius);
    ctx.lineTo(x + w, y + h - radius);
    ctx.quadraticCurveTo(x + w, y + h, x + w - radius, y + h);
    ctx.lineTo(x + radius, y + h);
    ctx.quadraticCurveTo(x, y + h, x, y + h - radius);
    ctx.lineTo(x, y + radius);
    ctx.quadraticCurveTo(x, y, x + radius, y);
    ctx.closePath();

    ctx.fillStyle = bgColor;
    ctx.fill();
    ctx.strokeStyle = theme.borderColor;
    ctx.stroke();

    // texto centrado
    ctx.fillStyle = textColor;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.font = "13px sans-serif";
    ctx.fillText(label, rect.x + rect.width / 2, rect.y + rect.height / 2);

    ctx.restore();
    return true;
    // const { ctx, theme, rect } = args;
    // const { label } = cell.data;

    // ctx.save();
    // ctx.beginPath();
    // ctx.rect(rect.x, rect.y, rect.width, rect.height);
    // ctx.clip();

    // const buttonColor = theme.bgCell;
    // const textColor = theme.textDark;

    // // fondo del botón
    // ctx.fillStyle = buttonColor;
    // ctx.fillRect(rect.x + 4, rect.y + 4, rect.width - 8, rect.height - 8);

    // // borde
    // ctx.strokeStyle = theme.borderColor;
    // ctx.strokeRect(rect.x + 4, rect.y + 4, rect.width - 8, rect.height - 8);

    // // texto centrado
    // ctx.fillStyle = textColor;
    // ctx.textAlign = "center";
    // ctx.textBaseline = "middle";
    // ctx.fillText(label, rect.x + rect.width / 2, rect.y + rect.height / 2);

    // ctx.restore();
    // return true;
  },

  // editor overlay (botón interactivo real)
  provideEditor: () => {
    return (p) => {
      const { data } = p.value;
      const { label, onClick, value, disabled } = data;
      const [hover, setHover] = React.useState(false);

      return (
        <button
          disabled={disabled}
          onClick={() => onClick(value)}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          style={{
            padding: "6px 12px",
            borderRadius: 6,
            border: "1px solid #ccc",
            backgroundColor: hover ? "#0078d4" : "#f4f4f4",
            color: hover ? "white" : "black",
            cursor: disabled ? "not-allowed" : "pointer",
            transition: "background 0.2s, color 0.2s",
            fontSize: 13,
            fontWeight: "bold"
          }}
        >
          {label}
        </button>
      );
    };
  },
};